































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Project } from '@/types'
import YoutubeEmbed from '../components/YoutubeEmbed.vue'
import ProjectTitleElements from './ProjectTitleElements.vue'

@Component({ components: { YoutubeEmbed, ProjectTitleElements } })
export default class extends Vue {
  dialog = false
  showScrollPrompt = true

  updateScroll(el: any) {
    const top = el.scrollTop
    const topMax = el.scrollHeight - el.clientHeight
    if (top >= topMax - 20) {
      this.showScrollPrompt = false
      return true
    }
    this.showScrollPrompt = true
    return false
  }

  stillScrolling = false
  scrollDownPress() {
    if (this.stillScrolling) return

    const scrollRef: Element = this.$refs.scrollRef as Element
    const options = {
      container: '#' + scrollRef.id,
      easing: 'ease-in-ease-out',
      offset: 400 + scrollRef.scrollTop,
      force: true,
      cancelable: true,
      onStart: () => {
        this.stillScrolling = true
      },
      onDone: () => {
        this.stillScrolling = false
      },
      onCancel: () => {
        this.stillScrolling = false
      },
      x: false,
      y: true
    }
    this.$scrollTo('#' + scrollRef.id, 500, options)
  }

  get details() {
    return this.project.details
  }

  get project(): Project {
    return this.$store.state.currentProject
  }

  @Watch('dialog')
  onDialogChanged(newDialog: boolean) {
    if (!newDialog) {
      this.$store.commit('SET_PROJECT', undefined)
    }
  }

  @Watch('project')
  onProjectChanged(newProject: Project, oldProject: Project) {
    this.dialog = newProject !== undefined
  }
}
